import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { useEffect } from "react";
import Toast from "../../components/Toast";
import { getAllProductCategory } from "../../actions/ProductCategoryActions";
import { getAllProduct, saveProduct } from "../../actions/ProductActions";
import { styleSelect } from "../../constants/customStyles";
import Select from 'react-select';

function AddProduct() {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const productCategories = useSelector(state => state?.productCategory?.productCategories?.data)

    const [name, setName] = useState('');
    const [costPrice, setCostPrice] = useState('');
    const [salePrice, setSalePrice] = useState('');
    const [variant, setVariant] = useState('');
    const [type, setType] = useState('');
    const [productCategory, setProductCategory] = useState('');

    const save = async () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else if (productCategory.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Product Category is Required!'
            })
        } else {
            let data = {
                name: name,
                // cost_price: costPrice,
                // sale_price: salePrice,
                // item_code: itemCode,
                product_type: type,
                product_category_id: productCategory
            }
            await dispatch(saveProduct(data));
            dispatch(getAllProduct(null, 9999))
        }
        // window.location.href = ('/state');
    }

    const Options = [
        { label: 'Spare Parts', value: 'spare' },
        { label: 'Repair', value: 'repair' },
    ]
    return (
        <React.Fragment>
            {/* <!-- BEGIN: Modal Content --> */}
            <div id="add-product-modal" class="modal fade" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div class="modal-header">
                            <h2 class="fw-medium fs-base me-auto">Add Product</h2>
                        </div>
                        {/* <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="intro-y p-5">
                            <div className="grid columns-12 gap-6">
                                <div className="intro-y g-col-12 g-col-sm-4">
                                    <label for="name" className="form-label">Name :</label>
                                    <input id="name" name="name" onChange={(e) => setName(e.target.value)} type="text" className="form-control" placeholder="Enter Name" />
                                </div>
                                {/* <div className="intro-y g-col-12 g-col-sm-6">
                                    <label for="variant" className="form-label">Product Variant :</label>
                                    <input id="variant" name="variant" type="text" onChange={(e) => setVariant(e.target.value)} className="form-control" placeholder="Enter Product Variant" />
                                </div> */}
                                <div className="g-col-12 g-col-md-4">
                                    <label for="crud-form-1" className="form-label">Product Category</label>
                                    <Select styles={styleSelect} onChange={(e) => setProductCategory(e.id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.id}`} options={productCategories && productCategories.length > 0 ? productCategories : []} />
                                </div>
                                <div className="g-col-12 g-col-md-4">
                                    <label for="crud-form-1" className="form-label">Product Type</label>
                                    <Select styles={styleSelect} onChange={(e) => setType(e.value)} options={Options} />
                                </div>
                                {/* <div className="intro-y g-col-12 g-col-sm-6">
                                    <label for="image" className="form-label">Image :</label>
                                    <input id="image" name="image" type="file" className="form-control" />
                                </div> */}
                            </div>
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div class="modal-footer text-end">
                            <div className="text-end">
                                <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-24 me-1">Back</button>
                                <span>
                                    <button type="button" data-bs-dismiss="modal" onClick={save} className="btn btn-primary w-24 me-1">Save</button>
                                    <button type="button" onClick={save} className="btn btn-primary">Save & Add More</button>
                                </span>
                            </div>
                        </div>
                        {/* <!-- END: Modal Footer --> */}
                    </div>
                </div>
            </div>
            {/* <!-- END: Modal Content --> */}
        </React.Fragment>
    )
}

export default AddProduct;